import { Paragraph, Subheading, UnorderedList } from '@treams/treams-ui';
import * as graphql from 'generated/graphql';
import { SharedFields } from '../ProductConfiguration';

import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'environmentID') {
		return {
			title: 'Omgevings-ID',
			description:
				'Vul het omgevings-id in van de AFAS omgeving. Dit bestaat uit 5 cijfers, zonder letters. (Correct: 12345, incorrect: O12345)',
		};
	}

	if (key === 'authToken') {
		return {
			title: 'Toegangssleutel',
			description:
				'Vul het de toegangssleutel in. Deze begint met <token> en eindigt met </token>.',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

function Description() {
	return (
		<>
			<Paragraph mb={2}>
				Werk kan zo veel leuker en beter. En met meer oog voor de maatschappij. In veel organisaties
				zijn mensen druk met de verkeerde dingen. Onnodige handelingen, dubbel werk, fouten
				herstellen: het kost handenvol tijd en komt de kwaliteit niet ten goede. De missie van AFAS
				Software is: inspireert beter ondernemen. Dat doet AFAS met software en alles wat ervoor
				nodig is om die software zo te gebruiken dat je er een hoger doel mee bereikt. Organisaties
				houden tijd over voor wat ze echt belangrijk vinden, kwaliteit en werkplezier.
			</Paragraph>
			<Subheading>Jouw voordelen:</Subheading>
			<Paragraph>
				<UnorderedList>
					<li>Volledig in de cloud werken</li>
					<li>Eenmalige invoer van data</li>
					<li>Vast bedrag per maand</li>
					<li>Na 1 jaar dagelijks opzegbaar</li>
					<li>Nederlandse softwarepartner</li>
					<li>Innovaties in de software worden constant toegevoegd</li>
					<li>Werken via een app of het web</li>
					<li>De data staat in Nederland volgens de Nederlandse wetgeving</li>
					<li>Dagelijkse back-up</li>
				</UnorderedList>
			</Paragraph>
			<Paragraph mb={2}></Paragraph>
		</>
	);
}

export default function Afas() {
	return (
		<ProductLayout
			id="afas"
			type={graphql.ConnectorType.Afas}
			description={<Description />}
			headerImageURL="https://assets.ontreams.com/marketplace/afas-wide.jpg"
			translate={translate}
			pricingLink="https://www.afas.nl/software/prijzen"
			price={125}
			documentationLink="https://treams.notion.site/Uitleg-AFAS-integreren-met-Treams-50241175a1e9420f9f1e16e12095fa95"
		/>
	);
}

export function AfasTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="afas"
			title="AFAS"
			description="Stroomlijn bedrijfsprocessen met één systeem."
			logoImageURL="https://assets.ontreams.com/marketplace/afas.png"
			selected={props.selected}
			price={125}
		/>
	);
}
